"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUncontrolledValueSync = void 0;
var react_1 = require("react");
// Keeps an uncontrolled <input>'s DOM value aligned with an external value (e.g. a MobX store)
// without touching the element while the user is composing text in it (IME-safe).
var useUncontrolledValueSync = function (entries) {
    var key = JSON.stringify(entries.map(function (entry) { return entry.value; }));
    (0, react_1.useEffect)(function () {
        entries.forEach(function (_a) {
            var getElement = _a.getElement, value = _a.value;
            var element = getElement();
            var isReset = value === '';
            if (element && (element !== document.activeElement || isReset) && element.value !== value) {
                element.value = value;
            }
        });
    }, [key]);
};
exports.useUncontrolledValueSync = useUncontrolledValueSync;
